import axios from 'Src/helpers/api/axiosInstance';
import { AppUser } from 'Src/views/App/App';
import { DEFAULT_FILTER } from './user';
import { DEFAULT_LIMIT, DEFAULT_SKIP } from 'Src/consts/table';
import { Count } from '../../../models/count';

export function getSchoolClubMessages(user: AppUser, filter = DEFAULT_FILTER, invitationView?: string) {
  const { roleSessionKey: key, activeSchoolId } = user;

  const config = {
    headers: { usid: key },
    params: {
      filter,
      ...(invitationView ? { invitationView } : {})
    }
  };

  return axios.get(`${window.apiBase}/i/schools/${activeSchoolId}/clubs/messages`, config).then(response => {
    return response.data;
  });
}

export function getAllSchoolClubMessages(user: AppUser, where?, invitationView?: string) {
  const { roleSessionKey: key, activeSchoolId } = user;

  let config;

  if (typeof where !== 'undefined') {
    config = {
      headers: { usid: key },
      params: {
        filter: {
          where: {
            ...where
          },
          limit: DEFAULT_LIMIT,
          skip: DEFAULT_SKIP
        },
        ...(invitationView ? { invitationView, includeCount: 'false' } : {})
      }
    };
  } else {
    config = {
      headers: { usid: key },
      params: {
        filter: {
          limit: DEFAULT_LIMIT,
          skip: DEFAULT_SKIP
        },
        ...(invitationView ? { invitationView, includeCount: 'false' } : {})
      }
    };
  }

  return axios.get(`${window.apiBase}/i/schools/${activeSchoolId}/clubs/messages`, config).then(response => {
    return Array.isArray(response.data) ? response.data : response.data.items || [];
  });
}

export function getSchoolClubMessagesCount(user: AppUser, where?, invitationView?: string): Promise<Count> {
  const { roleSessionKey: key, activeSchoolId } = user;

  let config;

  if (typeof where !== 'undefined') {
    config = {
      headers: { usid: key },
      params: {
        filter: {
          where: where
        },
        ...(invitationView ? { invitationView } : {})
      }
    };
  } else {
    config = {
      headers: { usid: key },
      params: invitationView ? { invitationView } : undefined
    };
  }

  return axios
    .get<Count>(`${window.apiBase}/i/schools/${activeSchoolId}/clubs/messages/count`, config)
    .then(response => {
      return response.data;
    });
}
